import React from 'react';
import s from './NotFound.module.css';
import Ribbon from '../../components/Ribbon/Ribbon';
import Container from '../../components/Container/Container';
import { Link } from 'react-router-dom';
import Button from '../../components/Button/Button';

export default function NotFound() {
  return (
    <div className={s.NotFound}>
      <div className={s.ribbon}>
        <Container>
          <div className={s.backgroundImage}></div>
          <div className={s.notFoundTextWrapper}>
            <p className={s.notFoundText}>
              Схоже, даної сторінки не існує... <br />
              Але нехай тебе це не зупиняє!
            </p>
          </div>
          <ul className={s.ButtonList}>
            <Link to={'/'}>
              <Button name={'Головна'} border={'#ffffff'} width={'134px'} />
            </Link>
            <Link to={'/drivers'}>
              <Button
                name={'Драйвера та підтримка'}
                border={'#ffffff'}
                width={'263px'}
              />
            </Link>
            <Link to={'/contacts'}>
              <Button
                name={`Зв'яжіться з нами`}
                border={'#ffffff'}
                width={'216px'}
              />
            </Link>
          </ul>
        </Container>
      </div>
      <div className={s.wrapper}>
        <Ribbon />
      </div>
    </div>
  );
}
